import React from 'react';

class AboutPage extends React.Component {
    render() {
        return (
            <div className="container">
            <div className="jumbotron">
                <h1 className="display-4">About</h1>
                <p className="lead">
                    I started building Handy Maps in December, 2019, right after I learnt <a href="https://reactjs.org/" target="_blank" rel="noopener noreferrer">React</a> from <a href="https://www.freecodecamp.org/" target="_blank" rel="noopener noreferrer">freeCodeCamp</a>.
                    </p>
                    <p className="lead">It served me two purposes:
                    <ul>
                        <li>I wanted to practise building React apps.</li>
                        <li>It gave me a reason to learn more about US history and its national trends (which is something I'm always interested in).</li>
                        </ul>
                </p>
                <hr />
                <h4>Find me here:</h4>
                <p className="lead">
                <ul>
                    <li><a href="https://twitter.com/crunchysonnets" target="_blank" rel="noopener noreferrer">Twitter</a></li>
                    <li><a href="https://dhruvs.space" target="_blank" rel="noopener noreferrer">Blog</a></li>
                    <li><a href="https://www.linkedin.com/in/dhruvthakur/" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
                    <li><a href="https://github.com/dhth" target="_blank" rel="noopener noreferrer">Github</a></li>
                </ul>
                </p>
                <hr />
                <h4>Credits:</h4>
                <p className="lead">
                    This website makes use of the awesome map visualization library <a href="https://datamaps.github.io/" target="_blank" rel="noopener noreferrer">DataMaps</a> by <a href="https://github.com/markmarkoh" target="_blank" rel="noopener noreferrer">Mark DiMarco</a>.
                    {/* <span>&#128578;</span> */}
                </p>
            </div>
            </div>
        );
    }
}

export default AboutPage;